import {
  CURRENT_COMPANY_ID_HEADER_KEY,
  SILENT_REQUEST_HEADER_KEY,
} from "@hd/http-client/constants";
import httpClient from "@hd/http-client/http-client";

type HandshakeType = "operator" | "contact";

interface HandshakeResponse {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
}

// la factory gira sul path critico di negotiate/reconnect: se l'endpoint si impianta non deve bloccare tutto all'infinito
const HANDSHAKE_TIMEOUT_MS = 15000;

// il bearer dell'app lo mette già l'interceptor di httpClient, qui aggiungo company id e silenzio il loader globale (gira a ogni reconnect)
export async function requestOperatorChatToken(
  companyId: number,
  customUserId?: string,
): Promise<string> {
  const result = await httpClient.post<HandshakeResponse>(
    `${import.meta.env.VITE_HD_CHAT_OPERATOR_URL}/api/handshake`,
    { type: "operator" satisfies HandshakeType, key: customUserId },
    {
      timeout: HANDSHAKE_TIMEOUT_MS,
      headers: {
        [SILENT_REQUEST_HEADER_KEY]: "true",
        [CURRENT_COMPANY_ID_HEADER_KEY]: companyId,
      },
    },
  );

  if (result.data?.tokenType !== "Bearer" || !result.data?.accessToken) {
    throw new Error("Handshake operatore senza accessToken valido");
  }

  return result.data.accessToken;
}
